import { Box, Button, createStyles, Text, Title } from "@mantine/core";
import { useEffect, useState } from "react";
import "./style.css";
import CreateClaim from "../../../components/ClaimBilling/createClaim";
import PreviousClaims from "../../../components/ClaimBilling/previousClaims";
import BillingAgree from "../../../components/ClaimBilling/BillingAgree";
import { getInvoicesSetting } from "../../../services/invoicesetting";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { useSelector } from "react-redux";

const useStyles = createStyles(() => ({
  back: {
    marginTop: "21px",
    marginBottom: "27px",
    display: "flex",
    gap: "1px",
    cursor: "pointer",
    alignSelf: "flex-start",
  },

  setupHero: {
    position: "relative", isolation: "isolate", overflow: "hidden",
    padding: "22px 28px 26px", display: "flex", flexDirection: "column",
    alignItems: "center", textAlign: "center", width: "100%", maxWidth: "none",
    margin: "0", background: "#f9f9fc", border: "1px solid #EAEAEF", borderRadius: "16px",
    "&::before": {
      content: '""', position: "absolute", inset: 0,
      backgroundImage: ["linear-gradient(to right, rgba(15,15,20,0.05) 1px, transparent 1px)", "linear-gradient(to bottom, rgba(15,15,20,0.05) 1px, transparent 1px)"].join(", "),
      backgroundSize: "36px 36px",
      maskImage: "radial-gradient(ellipse 95% 80% at 50% 30%, #000 30%, transparent 78%)",
      WebkitMaskImage: "radial-gradient(ellipse 95% 80% at 50% 30%, #000 30%, transparent 78%)",
      zIndex: -2, pointerEvents: "none",
    },
    "&::after": {
      content: '""', position: "absolute", left: "50%", top: "-100px",
      transform: "translateX(-50%)", width: "900px", height: "480px",
      background: "radial-gradient(closest-side, rgba(250,183,20,0.16), transparent 70%)",
      zIndex: -1, pointerEvents: "none",
    },
  },
  setupEyebrow: {
    display: "inline-flex", alignItems: "center", gap: "8px", margin: "0",
    padding: "4px 12px 4px 5px", borderRadius: "999px", background: "#fff",
    border: "1px solid #EAEAEF", boxShadow: "0 1px 2px rgba(15,15,20,0.04)",
    color: "#111", fontSize: "12px", fontWeight: 600,
  },
  setupEyebrowPip: {
    width: "18px", height: "18px", borderRadius: "999px", background: "#FAB714",
    display: "inline-flex", alignItems: "center", justifyContent: "center",
    color: "#111", fontWeight: 800, fontSize: "11px",
  },
  setupTitle: {
    margin: "12px 0 0", fontWeight: 700, fontSize: "40px", lineHeight: 1.04,
    letterSpacing: "-1.4px", color: "#0E0E10", maxWidth: "820px",
    "& em": {
      fontStyle: "normal", position: "relative", zIndex: 0,
      "&::after": {
        content: '""', position: "absolute", left: "-2px", right: "-2px",
        bottom: "4px", height: "9px", background: "#FAB714", opacity: 0.55,
        borderRadius: "4px", zIndex: -1,
      },
    },
  },
  setupLede: { margin: "10px 0 0", fontSize: "14px", color: "#3a3a40", lineHeight: 1.55, maxWidth: "660px" },
  setupPills: { listStyle: "none", margin: "14px 0 0", padding: 0, display: "flex", flexWrap: "wrap", gap: "8px", justifyContent: "center" },
  setupPillItem: {
    display: "inline-flex", alignItems: "center", gap: "8px", padding: "6px 12px",
    borderRadius: "999px", background: "#fff", border: "1px solid #EAEAEF",
    fontSize: "12.5px", fontWeight: 500, color: "#1a1a1f", whiteSpace: "nowrap",
    boxShadow: "0 1px 2px rgba(15,15,20,0.03)",
  },
  setupPillCheck: { color: "#FAB714", fontWeight: 700, fontSize: "13px", flexShrink: 0 },
  setupMock: {
    width: "100%", maxWidth: "920px", margin: "18px auto 0", background: "#fff",
    border: "1px solid #EAEAEF", borderRadius: "12px", overflow: "hidden",
    boxShadow: "0 8px 28px -10px rgba(15,15,20,0.10)", textAlign: "left",
    "& img": { width: "100%", display: "block" },
  },
  setupMockChrome: { display: "flex", alignItems: "center", gap: "6px", padding: "7px 12px", borderBottom: "1px solid #EAEAEF", background: "#fafafa" },
  setupMockDotRed:    { width: "9px", height: "9px", borderRadius: "999px", display: "inline-block", background: "#ff5f57" },
  setupMockDotYellow: { width: "9px", height: "9px", borderRadius: "999px", display: "inline-block", background: "#febb2e" },
  setupMockDotGreen:  { width: "9px", height: "9px", borderRadius: "999px", display: "inline-block", background: "#28c840" },
  setupMockUrl: { flex: 1, textAlign: "center", fontSize: "10.5px", color: "#6b7280", letterSpacing: "0.02em" },
  setupPillars: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginTop: "16px", width: "100%", maxWidth: "760px" },
  setupPillarCard: { background: "#fff", border: "1px solid #EAEAEF", borderRadius: "12px", padding: "12px 16px", textAlign: "left" },
  setupPillarEyebrow: { fontSize: "10px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.12em", color: "#8a5a08", display: "block", margin: 0 },
  setupPillarTitle: { fontWeight: 600, fontSize: "14.5px", letterSpacing: "-0.2px", color: "#111", margin: "4px 0 0", lineHeight: 1.3 },
  setupCloser: { margin: "16px 0 0", fontWeight: 500, fontSize: "14px", color: "#1a1a1f" },
  setupCtaWrap: { display: "flex", justifyContent: "center", marginTop: "10px" },
  setupCta: {
    background: "#FAB714", color: "#111", border: 0, borderRadius: "10px",
    padding: "0 22px", height: "44px", fontSize: "14.5px", fontWeight: 700,
    letterSpacing: "-0.3px", cursor: "pointer", display: "inline-flex", alignItems: "center",
    gap: "8px", boxShadow: "0 6px 18px rgba(250,183,20,0.30)",
    "&:hover": { background: "#ffc452" },
  },
  claimsTableMockImage: { padding: 4, "& > img": { height: "100%", width: "100%" } },
}));

const Billing = () => {
  const [open, setOpen] = useState(false);
  const [agreeOpen, setAgreeOpen] = useState(false);
  const { profile } = useSelector((state) => state?.profile);
  const [claimdetails, setClaimDetails] = useState(false);
  const [decryptedBillingData, setDecryptedBillingData] = useState(null);

  const { classes } = useStyles();

  useEffect(() => {
    getInvoicesSetting();
  }, []);

  if (!profile?.admin?.billingAgree) {
    return (
      <Box fluid className="content">
        <AppNavbar title="Billing" profile={profile} />
        <div className="mainbillingcontainer">
          <Box className={classes.setupHero}>
            <Box component="span" className={classes.setupEyebrow}>
              <Box component="span" className={classes.setupEyebrowPip}>$</Box>
              Billing
            </Box>

            <Title order={1} className={classes.setupTitle}>
              Billing Made <em>Simple</em>.
            </Title>

            <Text className={classes.setupLede}>
              Managing billing should not slow you down. Our billing feature was
              built directly into your workflow so you can focus on care while
              staying confident in your revenue cycle.
            </Text>

            <Box component="ul" className={classes.setupPills}>
              <Box component="li" className={classes.setupPillItem}>
                <Box component="span" className={classes.setupPillCheck}>✓</Box>
                Bill over 6,000 payers across the US
              </Box>
              <Box component="li" className={classes.setupPillItem}>
                <Box component="span" className={classes.setupPillCheck}>✓</Box>
                Submit claims individually or in bulk
              </Box>
              <Box component="li" className={classes.setupPillItem}>
                <Box component="span" className={classes.setupPillCheck}>✓</Box>
                Reduce errors and speed up approvals
              </Box>
            </Box>

            <Box className={classes.setupMock}>
              <Box className={classes.setupMockChrome}>
                <Box component="span" className={classes.setupMockDotRed} />
                <Box component="span" className={classes.setupMockDotYellow} />
                <Box component="span" className={classes.setupMockDotGreen} />
                <Text className={classes.setupMockUrl}>app.ogiso.io / billing / claims</Text>
              </Box>
              <Box className={classes.claimsTableMockImage}>
                <img src="/assets/images/billing-claim-table-img.jpg" alt="Billing preview" />
              </Box>
            </Box>

            <Box className={classes.setupPillars}>
              <Box className={classes.setupPillarCard}>
                <Text component="span" className={classes.setupPillarEyebrow}>Full Visibility</Text>
                <Text className={classes.setupPillarTitle}>Track claims and payments in real time.</Text>
              </Box>
              <Box className={classes.setupPillarCard}>
                <Text component="span" className={classes.setupPillarEyebrow}>Built for Providers</Text>
                <Text className={classes.setupPillarTitle}>Simple and accurate.</Text>
              </Box>
            </Box>

            <Text className={classes.setupCloser}>Start billing with confidence.</Text>

            <Box className={classes.setupCtaWrap}>
              <Button className={classes.setupCta} onClick={() => setAgreeOpen(true)}>
                Get Started
              </Button>
            </Box>
          </Box>
        </div>

        <BillingAgree open={agreeOpen} setOpen={setAgreeOpen} />
      </Box>
    );
  }

  return (
    <Box fluid className="content">
      <AppNavbar title="Billing" profile={profile} />
      <div style={{ flexDirection: "column" }} className="mainbillingcontainer">
        {!claimdetails ? <CreateClaim /> : null}

        {claimdetails ? (
          <Box
            onClick={() => { setClaimDetails(false); setDecryptedBillingData(null); }}
            className={classes.back}
          >
            <img width={20} src="/assets/images/chevron-backeleft.png" alt="back-icon" />
            <Text ff="Inter" fz={12} fw={400} color="#262626">Back</Text>
          </Box>
        ) : null}

        <PreviousClaims
          setClaimDetails={setClaimDetails}
          decryptedBillingData={decryptedBillingData}
          setDecryptedBillingData={setDecryptedBillingData}
        />
      </div>
    </Box>
  );
};

export default Billing;
